var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "3f26b901a8dfdddc6e2072e69ef2b79a.png",
    width: 988,
    height: 1023
});